import { render } from "./ebayDetails.vue?vue&type=template&id=22019d38"
import script from "./ebayDetails.vue?vue&type=script&lang=js"
export * from "./ebayDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__